export default __webpack_public_path__ + "static/media/anthonypena-2.1d61deb3.jpeg";